import { getUserInfo } from '@marriott/mi-store-utils';
import { useEffect, useRef } from 'react';

export interface UseGetUserInfoOptions {
  enabled: boolean;
  requestId: string | undefined;
  currentLocale: string | undefined;
}

/**
 * Calls getUserInfo once per mount as soon as a session token is available.
 * A ref guard prevents duplicate calls even when sessionData, requestId, or
 * currentLocale change after the initial invocation (e.g. after a client-side
 * session refresh), which avoids infinite re-render loops.
 *
 * This hook fetches user details from /mi/phoenix-account-auth/v2/userDetails
 * and stores them in userDetailsGlobalStore for use across the application.
 */
export function useGetUserInfo({ enabled, requestId, currentLocale }: UseGetUserInfoOptions): void {
  const calledRef = useRef(false);

  useEffect(() => {
    if (!enabled || calledRef.current) return;
    calledRef.current = true;

    getUserInfo(false, {
      'x-request-id': requestId,
      'accept-language': currentLocale || '',
    });
  }, [requestId, currentLocale, enabled]);
}
